import React from "react";
import Popup from "../Popup/BasePopup";
import PremiumTextLogo from "../Common/PremiumTextLogo";
import Button from "../CommonFields/Button";

const RequestSubmitPopup = ({ isOpen, onClose, title,payloadInfo }) => {
  console.log(payloadInfo)

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Popup isOpen={isOpen} onClose={onClose} title={title}>
      <PremiumTextLogo />
      <div className="d-flex flex-column align-items-center mb-5">
      <p className="f-16 text-subscription mb-4">
        your request has been submitted successfully
      </p>
      <p className="f-16 text-subscription mb-0">you will receive a call between</p>
      {/* <p className="f-16 text-subscription mb-0">{payloadInfo.callTime} on {payloadInfo.callDate} </p> */}
      <p className="f-16 text-subscription mb-0">
          {payloadInfo.callTime} on {formatDate(payloadInfo.callDate)}
        </p>
      </div>
      <div className="mt-4" onClick={onClose}>
        <Button text={"done"} />
      </div>
    </Popup>
  );
};

export default RequestSubmitPopup;
